import { handleActions } from "redux-actions";
import {
    clearPublishRequests,
    getPublishRequest,
    getPublishRequestError,
    getPublishRequestSuccess,
    mergeAcceptPublishRequestDialog,
    mergeTestCases,
    setAcceptPublishRequestDialog,
    setTestTasks
} from "modules/ConfigCI/services/PublishRequests/actions";

const initialState = {
    isLoading: false,
    publishRequests: [],
    count: 0,
    testTasks: {},
    testCases: {},
    reportCaseDialog: {
        isOpen: false,
        isLoading: false,
        content: ""
    },
    acceptPublishRequestDialog: { isOpen: false }
};

export const publishRequestsReducer = handleActions(
    {
        [clearPublishRequests]: () => ({ ...initialState }),

        [setTestTasks]: (state, { payload }) => ({
            ...state,
            testTasks: payload
        }),

        [mergeTestCases]: (state, { payload }) => ({
            ...state,
            testCases: {
                ...state.testCases,
                ...payload
            }
        }),

        [setAcceptPublishRequestDialog]: (state, { payload }) => ({
            ...state,
            acceptPublishRequestDialog: {
                ...initialState.acceptPublishRequestDialog,
                ...payload
            }
        }),
        [mergeAcceptPublishRequestDialog]: (state, { payload }) => ({
            ...state,
            acceptPublishRequestDialog: {
                ...state.acceptPublishRequestDialog,
                ...payload
            }
        }),

        [getPublishRequest]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getPublishRequestSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            publishRequests: payload.publishRequests,
            count: payload.count
        }),
        [getPublishRequestError]: (state) => ({
            ...state,
            isLoading: false
        })
    },
    initialState
);
